import React, { useContext, useEffect, useState } from "react";
import globalComp from "../../../global/components";
import { fabric } from "fabric";

const wordfind = require("../../../util/wordfind");
import { CanvasContext, ModuleContext } from "../provider";
import ff, { commonStyle } from "../../../util/fabric";

let wordTypingTimer: any = 0;

function WordMultiple_Prd() {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { canvasRef, scaledCanvasSize } = useContext(CanvasContext);
  const { setModuleInfo, moduleInfo } = useContext(ModuleContext);

  const [words, setWords] = useState<string[]>(["", "", "", ""]);
  const [country, setCountry] = useState<string>("it");
  const [trigger, setTrigger] = useState<number>(0);

  useEffect(() => {
    setModuleInfo({
      ...moduleInfo,
      ...commonStyle,
    });
  }, []);

  useEffect(() => {
    try {
      setCountry(window.Cookies.get("pll_language").toLowerCase());
    } catch (e) {
      setCountry(window.INITIAL_DATA.TRANSLATIONS.toLowerCase());
      console.log(e);
    }
  }, []);

  useEffect(() => {
    if (country && canvasRef.current && scaledCanvasSize) {
      // clear previous objects
      canvasRef.current.remove(...canvasRef.current.getObjects());
      let gridWidth = 19;
      let gridHeight = 15;
      let letterWidth = canvasRef.current.getWidth() / gridWidth;
      let letterHeight = canvasRef.current.getHeight() / gridHeight;
      let topOffset = letterHeight / 5;

      let puzzle = wordfind(words, gridWidth, gridHeight, country);

      let index = 0;
      for (let i = 0; i < puzzle.grid.length; i++) {
        let row = puzzle.grid[i];
        for (let j = 0; j < row.length; j++) {
          const { top, left, width, height } = ff.handleWordPositioner(
            canvasRef.current,
            gridWidth,
            gridHeight,
            index,
            topOffset
          );
          let letter = row[j];
          let text = new fabric.Textbox(letter, {
            // @ts-ignore
            id: index,
            left: left,
            top: top,
            width: width,
            height: height,
            textAlign: "center",
            fill: "#404040",
            fontFamily: "Calibri",
            fontSize: window.innerWidth < 768 ? 12 : 20,
            lockScalingFlip: true,
            lockScalingX: true,
            lockUniScaling: true,
            lockSkewingX: true,
            selectable: false,
            hoverCursor: "default",
            rx: 8,
            ry: 8,
          });
          text.set({
            width: text.height,
            left: text.left + (text.width - text.height) / 2,
          });
          puzzle.keywords.map((word) => {
            if (word.startingX == j && word.startingY == i) {
              text.backgroundColor = "#d4d4d4";
            }
          });
          canvasRef.current.add(text);
          index++;
        }
      }
    }
  }, [country, canvasRef.current, trigger, scaledCanvasSize]);

  function handleWordChange(word: string, index: number) {
    let regex = /^[a-zA-Z]+$/;
    if (country == "ru") regex = /[\wа-яA-Я]+/gi;
    if (regex.test(word) || word == "") {
      let tempWords = JSON.parse(JSON.stringify(words));
      if (wordTypingTimer) clearTimeout(wordTypingTimer);
      tempWords[index] = word.toUpperCase();
      setWords(tempWords);
      wordTypingTimer = setTimeout(() => {
        setTrigger(trigger + 1);
      }, 500);
    }
  }

  return (
    <div>
      <globalComp.FieldHeader
        number={1}
        title={t.write_your_words}
        tooltipStr={t.tooltip_write_your_words}
        element={
          <>
            <div className={"container-fluid p-0 mb-1"}>
              <div className={"row no-gutters"}>
                <div className={"col-6 col-md-3 d-flex pr-1 pr-md-2 mb-2"}>
                  <globalComp.TextInput
                    placeholderStr={t.word_1}
                    extraCssClass={"flex-grow-1 w-100"}
                    onChange={(event) => {
                      handleWordChange(event.target.value, 0);
                    }}
                    maxStrLength={15}
                  />
                </div>
                <div className={"col-6 col-md-3 d-flex pl-1 pr-md-2 mb-2"}>
                  <globalComp.TextInput
                    placeholderStr={t.word_2}
                    extraCssClass={"flex-grow-1 w-100"}
                    onChange={(event) => {
                      handleWordChange(event.target.value, 1);
                    }}
                    maxStrLength={15}
                  />
                </div>
                <div className={"col-6 col-md-3 d-flex pr-1 pr-md-2 mb-2"}>
                  <globalComp.TextInput
                    placeholderStr={t.word_3}
                    extraCssClass={"flex-grow-1 w-100"}
                    onChange={(event) => {
                      handleWordChange(event.target.value, 2);
                    }}
                    maxStrLength={15}
                  />
                </div>
                <div className={"col-6 col-md-3 d-flex pl-1 pr-md-2 mb-2"}>
                  <globalComp.TextInput
                    placeholderStr={t.word_4}
                    extraCssClass={"flex-grow-1 w-100"}
                    onChange={(event) => {
                      handleWordChange(event.target.value, 3);
                    }}
                    maxStrLength={15}
                  />
                </div>
              </div>
            </div>

            <p className={"product-section__description px-3 mb-0"}>
              {`${t.paper_instructions}`}
            </p>
          </>
        }
      />
      <globalComp.FieldHeader
        number={2}
        title={t.checkout_preview_image}
        tooltipStr={t.tooltip_checkout_preview_image}
        extraCssClass={"pb-1"}
        element={<></>}
      />
    </div>
  );
}

export default WordMultiple_Prd;
